import { Token } from '../token/token'
import { Wei } from '../../utils/types'
import { oracleApi } from '../../api/oracle/oracle-client'
import { fromWei } from '../../utils/static-web3'

export async function calculateBagInDollar(
  amounts: Map<Token, Wei>
): Promise<number> {
  let val = 0

  await oracleApi.getPrices()
  Array.from(amounts.entries()).forEach(
    ([token, amount]) =>
      (val += oracleApi.getPrice(token.symbol) * fromWei(amount, token.decimals))
  )
  return val
}
